
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';

export default defineComponent({
    components: { FbxButton },
    emits: ['onManualAttach'],
    props: {
        text: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
        },
    },
});
